import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  FaArrowLeft,
  FaCamera,
  FaClock,
  FaLightbulb,
  FaMapMarkerAlt,
  FaRoute,
  FaStar,
} from "react-icons/fa";
import NavBar from "./nav";
import Footer from "./footer";
import VisitorTips from "./VisitorTips";
import { placesToVisit } from "./placeData";
import "../css/placeDescription.css";

const PlaceDescription = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { slug } = useParams();
  const place =
    location.state?.place || placesToVisit.find((item) => item.slug === slug);

  if (!place) {
    return (
      <div className="place-description-page">
        <NavBar />
        <main className="place-detail-container">
          <button className="place-detail-back" onClick={() => navigate(-1)} type="button">
            <FaArrowLeft />
            Back
          </button>
          <section className="place-empty-state">
            <h1>Place not found</h1>
            <p>Please return to the homepage and choose a destination.</p>
          </section>
        </main>
        <Footer />
      </div>
    );
  }

  const relatedPlaces = placesToVisit
    .filter((item) => item.slug !== place.slug)
    .slice(0, 3);

  return (
    <div className="place-description-page">
      <NavBar />
      <main className="place-detail-container">
        <button className="place-detail-back" onClick={() => navigate(-1)} type="button">
          <FaArrowLeft />
          Back
        </button>

        <article className="place-detail-shell">
          <header className="place-detail-hero">
            <div className="place-detail-image">
              <img src={place.image} alt={place.name} />
            </div>
            <div className="place-detail-copy">
              <p className="place-detail-eyebrow">
                <FaMapMarkerAlt />
                {place.category}
              </p>
              <h1>{place.name}</h1>
              <p>{place.description}</p>
              <div className="place-detail-meta">
                <span>
                  <FaMapMarkerAlt />
                  {place.location}
                </span>
                <span>
                  <FaClock />
                  Flexible visit
                </span>
              </div>
            </div>
          </header>

          <section className="place-detail-grid">
            <div className="place-detail-main">
              <div className="place-detail-section">
                <h2>Why Visit</h2>
                {place.content.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>

              <div className="place-detail-section">
                <h2>Highlights</h2>
                <div className="place-highlight-grid">
                  {place.highlights.map((highlight, index) => (
                    <div key={index}>
                      <FaStar />
                      <p>{highlight}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <aside className="place-detail-side">
              <div className="place-tip-card">
                <span>
                  <FaLightbulb />
                </span>
                <h2>Visitor Note</h2>
                <p>{place.visitorNotes}</p>
              </div>

              <div className="place-best-card">
                <h2>Best For</h2>
                <div>
                  {place.bestFor.map((item) => (
                    <span key={item}>{item}</span>
                  ))}
                </div>
              </div>

              <div className="place-related-card">
                <h2>Explore Nearby Ideas</h2>
                {relatedPlaces.map((item) => (
                  <button
                    key={item.slug}
                    type="button"
                    onClick={() =>
                      navigate(`/places/${item.slug}`, {
                        state: { place: item },
                      })
                    }
                  >
                    <FaRoute />
                    {item.name}
                  </button>
                ))}
              </div>
            </aside>
          </section>

          <section className="place-photo-note">
            <FaCamera />
            <p>
              This page keeps visitors inside the app when an official website is
              unavailable, while still giving them useful context before they go.
            </p>
          </section>
        </article>
      </main>
      <section className="detail-extra-section">
        <VisitorTips title={place.name} category={place.category || "Place"} />
      </section>
      <Footer />
    </div>
  );
};

export default PlaceDescription;
